import React from 'react';

import 'firebase/analytics';

import { RegionProvider } from './src/context/RegionContext';

export const wrapRootElement = ({ element }) => (
  <RegionProvider>{element}</RegionProvider>
);
